import {Organization} from './organization';

export class Review {
  id: string;
  organization: Organization;
  clientName: string;
  clientLocation: string;
  tripType: string;
  status: string;
  review: string;
  source: string;
  topReview: boolean;
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/models/review.ts